import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../static/icons/logout.svg'


const _hoisted_1 = { class: "my-pages-menu" }
const _hoisted_2 = { class: "my-pages-menu__header-title" }
const _hoisted_3 = { class: "my-pages-menu__list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "my-pages-menu__logout-caption" }
const _hoisted_6 = {
  key: 4,
  class: "my-pages-menu__error"
}

import { ref, computed } from 'vue';
import * as userConnector from '@/connectors/user';

import useContext from '@/composables/useContext';
import useExecuteCommand from '@/composables/useExecuteCommand';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getUserProviderContext } from '@/composables/useUserProvider';

import OrganizationSwitcher from './OrganizationSwitcher.vue';
import MenuArrow from './components/MenuArrow.vue';
import { WEBSITES } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPagesMenu',
  emits: ['navigateMenu', 'navigatePage', 'close'],
  setup(__props, { emit }) {



const { user, setPendingAuthState, setUser } = getUserProviderContext();
const { settings, environmentOptions } = useContext();
const { executeCommand } = useExecuteCommand();
const { websiteText } = useWebsiteTexts();

const error = ref('');

const userBelongsToSeveralOrganizations = computed(() => {
  return user.value?.organizations?.length > 1;
});

const showCompanyInformation = computed(() => {
  return user.value.organization;
});

const isInstaller = computed(() => {
  return user.value.organization?.installerData || false;
});

const installerCaption = computed(() => {
  return isInstaller.value
    ? websiteText('my_pages__dit_intaller_information').value
    : websiteText('my_pages__become_an_installer').value;
});

const canNavigateToReviewerPageUrl = computed(() => {
  return (settings.value?.reviewer?.cached_url || '') && user.value?.reviewerId;
});

function navigateMenu(menuItem: any) {
  emit('navigateMenu', menuItem);
}

function navigatePage(pageItem: any) {
  emit('navigatePage', pageItem);
}

async function logout() {
  try {
    error.value = '';
    setPendingAuthState();
    const response = await executeCommand(userConnector.commands.logout);

    if (response.error === 'NONE') {
      setUser({ isAuthenticated: false });
      emit('close');
    } else {
      error.value = websiteText('global__logout_failed').value;
    }

    return response;
  } catch (err: any) {
    error.value = err;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["my-pages-menu__header", {'my-pages-menu__header--border': !_unref(userBelongsToSeveralOrganizations)}])
    }, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(websiteText)('mypages__title').value), 1),
      (_unref(userBelongsToSeveralOrganizations))
        ? (_openBlock(), _createBlock(OrganizationSwitcher, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "my-pages-menu__list-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateMenu('orders')))
      }, [
        _createTextVNode(_toDisplayString(_unref(websiteText)('mypages__orders').value) + " ", 1),
        _createVNode(MenuArrow)
      ]),
      (
          _unref(environmentOptions) &&
          _unref(environmentOptions).siteId?.toLowerCase() ===
            _unref(WEBSITES).BLACK.toLowerCase()
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "my-pages-menu__list-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateMenu('my-rentals')))
          }, [
            _createTextVNode(_toDisplayString(_unref(websiteText)('mypages__rentals').value) + " ", 1),
            _createVNode(MenuArrow)
          ]))
        : _createCommentVNode("", true),
      (
          _unref(environmentOptions) &&
          _unref(environmentOptions).siteId?.toLowerCase() ===
            _unref(WEBSITES).WHITE.toLowerCase()
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "my-pages-menu__list-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateMenu('installer')))
          }, [
            _createTextVNode(_toDisplayString(_unref(installerCaption)) + " ", 1),
            _createVNode(MenuArrow)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "my-pages-menu__list-item",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateMenu('personProfile')))
      }, [
        _createTextVNode(_toDisplayString(_unref(websiteText)('mypages__profile').value) + " ", 1),
        _createVNode(MenuArrow)
      ]),
      (_unref(showCompanyInformation))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "my-pages-menu__list-item",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateMenu('organizationProfile')))
          }, [
            _createTextVNode(_toDisplayString(_unref(websiteText)('mypages__company_information').value) + " ", 1),
            _createVNode(MenuArrow)
          ]))
        : _createCommentVNode("", true),
      (_unref(canNavigateToReviewerPageUrl))
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "my-pages-menu__list-item",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (navigatePage('personReviews')))
          }, _toDisplayString(_unref(websiteText)('mypages__my_reviews').value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "my-pages-menu__logout",
        onClick: logout
      }, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(websiteText)('global__logout_label').value), 1)
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})